export default __webpack_public_path__ + "static/media/example-serie-img.a723cbca.png";